import Button from "core/buttons/button/Button";
import "./Modal.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "core/typography/Typography";
import InputText from "core/inputs/input-text/InputText";
import InputSelect from "core/inputs/input-select/InputSelect";
import { useSectorContext } from "api/settings/sector/SectorProvider";
import { useContext, useEffect, useState } from "react";
import {
  LANG,
  PROSPECTION_DEFAULT_COLORS,
  QUERY_STATUS,
  ADD_PROSPECTION_ERROR,
} from "constants/constants";
import InfoContext from "pages/InfoContext";

const AddProspectionModal = ({ closeModal }) => {
  const { sectorList } = useSectorContext();
  const { lang, addNewProspection, createProspectionStatus, errorData } =
    useContext(InfoContext);

  const [sector, setSector] = useState("");
  const [clientName, setClientName] = useState("");
  const [colorDefault, setColorDefault] = useState(null);
  const [isSectorValue, setIsSectorValue] = useState(true);
  const [isClientNameValue, setIsClientNameValue] = useState(true);
  const [isColorDefaultValue, setIsColorDefaultValue] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const intl = useIntl();

  useEffect(() => {
    sector && setIsSectorValue(true);
    clientName && setIsClientNameValue(true);
    colorDefault && setIsColorDefaultValue(true);
    sector && clientName && colorDefault && setErrorMessage("");
  }, [sector, clientName, colorDefault]);

  useEffect(() => {
    if (createProspectionStatus === QUERY_STATUS.SUCCESS) {
      closeModal();
    } else if (
      errorData.message === ADD_PROSPECTION_ERROR.ERROR_MAX_PROSPECTION
    ) {
      setErrorMessage(
        intl.formatMessage({
          id: "prospection_limit_reached",
          defaultMessage: "Vous avez atteint le nombre max. de prospections",
        })
      );
    } else if (
      errorData.message ===
      ADD_PROSPECTION_ERROR.ERROR_PROSPECTION_ALREADY_EXIST
    ) {
      setErrorMessage(
        intl.formatMessage({
          id: "prospection_name_already_exists",
          defaultMessage: "Nom de client déjà existant",
        })
      );
    }
  }, [createProspectionStatus, errorData]);

  const handleErrorMessage = () => {
    if (!sector || !clientName || !colorDefault) {
      setErrorMessage(
        intl.formatMessage({
          id: "all_inputs_required",
          defaultMessage: "Tous les champs sont obligatoires",
        })
      );
    }
  };

  const onSubmit = () => {
    !sector && setIsSectorValue(false);
    !clientName && setIsClientNameValue(false);
    !colorDefault && setIsColorDefaultValue(false);
    sector &&
      clientName &&
      colorDefault &&
      addNewProspection({
        sector_id: sector,
        name: clientName,
        default_color: colorDefault,
      });
    handleErrorMessage();
  };

  const formatSectorList = () =>
    sectorList.map((elm) => ({
      label: lang === LANG.EN ? elm?.en : elm?.fr,
      value: elm?.id,
    }));

  return (
    <>
      <div className="overlay-style" />
      <div className="tool-modal-style new-prospection-modal">
        <div className="header">
          <Typography
            className="title-3 violet text-uppercase"
            type="h2"
            label={
              <FormattedMessage
                id="new_prospection"
                defaultMessage="Nouvelle prospection"
              />
            }
          />
        </div>
        <div className="body">
          <div className="new_prospection_cells">
            <div className="line-1">
              <div
                className={`cell-padding ${
                  !isSectorValue && "input-missing-color"
                }`}
              >
                <InputSelect
                  overflow={"auto"}
                  required
                  errors={{}}
                  label={{
                    id: "input_sector_label",
                    defaultMessage: "Secteur",
                  }}
                  id="sector-title-filter"
                  setValue={(name, e) => {
                    setSector(e);
                  }}
                  value={sector}
                  options={formatSectorList()}
                />
              </div>
              <div
                className={`cell-padding ${
                  !isClientNameValue && "input-missing-color"
                }`}
              >
                <InputText
                  label={{
                    id: "filter_clients_tools_title",
                    defaultMessage: "Nom du client",
                  }}
                  value={clientName}
                  errors={{}}
                  onChange={(e) => setClientName(e.target.value)}
                  id="client-title-filter"
                  required
                />
              </div>
            </div>
            <div className="line-2">
              <div
                className={`cell-padding ${
                  !isColorDefaultValue && "input-missing-color"
                }`}
              >
                <InputSelect
                  required
                  errors={{}}
                  label={{
                    id: "input_default_color_label",
                    defaultMessage: "Couleur par défaut",
                  }}
                  id="default-color-title-filter"
                  options={PROSPECTION_DEFAULT_COLORS}
                  setValue={(name, e) => {
                    setColorDefault(e);
                  }}
                />
              </div>
            </div>
          </div>
          <p className="input-missing-color">{errorMessage}</p>
          <div className="new-prospection-modal-buttons">
            <Typography
              onClick={closeModal}
              className={"cancel-button text violet"}
              type={"h2"}
              label={
                <FormattedMessage id={"cancel"} defaultMessage={"Annuler"} />
              }
            />
            <Button
              className="add-button btn-hover-color"
              size="medium"
              color="blue"
              type="submit"
              onClick={() => onSubmit()}
            >
              <FormattedMessage id={"add"} defaultMessage={"Ajouter"} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProspectionModal;
